<!--
 by:wangyingyu
 2019.9.18
 -->
<template>
    <div class="searchBox" :class="{searchInput:inputFocus}">
        <i class="iconfont" v-show="!inputFocus">&#xe7ce;</i>
        <input type="text" placeholder="搜索" v-model="searchValue" @change="searchfriend" @click="searchshow">
        <a href="javascript:;" @click="searchclose" v-show="inputFocus">
            <i class="iconfont">&#xe6a8;</i>
        </a>
        <el-popover
        placement="bottom"
        width="332"
        v-model="showtip"
        trigger="manual">
            <div class="search_sel">
                <div class="sel_item">
                    <span>标签：</span>
                    <el-select
                        v-model="value1"
                        multiple
                        size="small"
                        popper-class="search_select_box"
                        style="margin-left: 8px;width:220px"
                        placeholder="请选择">
                        <div class="toolbox">
                            <el-input
                            placeholder="请输入内容"
                            v-model="input1"
                            ref="input1val"
                            @input="changeinput('tip')"
                            size="small"
                            clearable>
                            </el-input>
                            <div class="selbtn_box">
                                <el-button size="small" @click.stop="selall('tip',true)">全选</el-button>
                                <el-button size="small" @click.stop="selall('tip')">全不选</el-button>
                            </div>
                        </div>
                        <div class="toolbox emptybox" slot="empty">
                            <el-input
                            placeholder="请输入内容"
                            v-model="input1"
                            @input="changeinput('tip')"
                            size="small"
                            ref="input1no"
                            clearable>
                            </el-input>
                            <div class="selbtn_box">
                                <el-button size="small" @click.stop="selall('tip',true)">全选</el-button>
                                <el-button size="small" @click.stop="selall('tip')">全不选</el-button>
                            </div>
                            <div>
                                <p class="empty">无数据</p>
                            </div>
                        </div>
                        <div class="searchsel_con">
                            <el-option
                            v-for="item in tiplist"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </div>
                    </el-select>
                </div>
                <div class="sel_item">
                    <span>好友来源：</span>
                    <el-select
                        v-model="value2"
                        multiple
                        size="small"
                        popper-class="search_select_box"
                        style="margin-left: 8px;width:220px"
                        placeholder="请选择">
                        <div class="toolbox">
                            <el-input
                            placeholder="请输入内容"
                            v-model="input2"
                            ref="input2val"
                            @input="changeinput('way')"
                            size="small"
                            clearable>
                            </el-input>
                            <div class="selbtn_box">
                                <el-button size="small" @click.stop="selall('way',true)">全选</el-button>
                                <el-button size="small" @click.stop="selall('way')">全不选</el-button>
                            </div>
                        </div>
                        <div class="toolbox emptybox" slot="empty">
                            <el-input
                            placeholder="请输入内容"
                            v-model="input2"
                            ref="input2no"
                            @input="changeinput('way')"
                            size="small"
                            clearable>
                            </el-input>
                            <div class="selbtn_box">
                                <el-button size="small" @click="selall('way',true)">全选</el-button>
                                <el-button size="small" @click="selall('way')">全不选</el-button>
                            </div>
                            <div>
                                <p class="empty">无数据</p>
                            </div>
                        </div>
                        <div class="searchsel_con">
                            <el-option
                            v-for="(item,index) in passway"
                            :key="index"
                            :label="item.type"
                            :value="item.value">
                            </el-option>
                        </div>
                    </el-select>
                </div>
                <div class="sel_item">
                    <span>好友状态：</span>
                    <el-select
                        v-model="value3"
                        size="small"
                        clearable
                        popper-class="search_select_box"
                        style="margin-left: 8px;width:220px"
                        placeholder="请选择">
                        <el-option
                        v-for="item in friendstate"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="dialog-footer">
                    <el-button size="small" @click.stop="reset">重置</el-button>
                    <el-button size="small" type="primary" @click.stop="tipsearch">确定</el-button>
                </div>
            </div>
            <a href="javascript:;" slot="reference" class="btn_shai iconfont" :class="{'active':isactive}" @click.stop="gettips">&#xe6bf;</a>
        </el-popover>
    </div>
</template>

<script>
    const passiveAddWaySourceGroup = [
        {
        type:"对方通过搜索QQ号添加",
        value:"对方通过搜索QQ号添加"
        },
        {
            type:"对方通过搜索微信号添加",
            value:"对方通过搜索微信号添加"
        },
        {
            type:"对方来自QQ好友",
            value:"对方来自QQ好友"
        },
        {
            type:"对方通过群聊添加",
            value:"对方通过群聊添加"
        },
        {
            type:"对方通过手机通讯录添加",
            value:"对方通过手机通讯录添加"
        },
        {
            type:"对方通过搜索手机号添加",
            value:"对方通过搜索手机号添加"
        },
        {
            type:"对方通过名片分享添加",
            value:"对方通过名片分享添加"
            },
        {
            type:"对方通过附近的人添加",
            value:"对方通过附近的人添加"
        },
        {
            type:"对方通过摇一摇添加",
            value:"对方通过摇一摇添加"
        },
        {
            type:"对方通过漂流瓶添加",
            value:"对方通过漂流瓶添加"
        },
        {
            type:"对方通过扫一扫添加",
            value:"对方通过扫一扫添加"
        },
        {
            type:"对方公众号",
            value:"对方公众号"
        },
        {
            type:"对方雷达",
            value:"对方雷达"
        },
        {
            type:"对方通过Google联系人添加",
            value:"对方通过Google联系人添加"
        },
        {
            type:"对方通过LinkedIn添加",
            value:"对方通过LinkedIn添加"
        },
        {
            type:"通过搜索QQ号添加",
            value:"通过搜索QQ号添加"
        },
        {
            type:"通过搜索微信号添加",
            value:"通过搜索微信号添加"
        },
        {
            type:"来自QQ好友",
            value:"来自QQ好友"
        },
        {
            type:"通过群聊添加",
            value:"通过群聊添加"
        },
        {
            type:"通过手机通讯录添加",
            value:"通过手机通讯录添加"
        },
        {
            type:"通过搜索手机号添加",
            value:"通过搜索手机号添加"
        },
        {
            type:"通过名片分享添加",
            value:"通过名片分享添加"
        },
        {
            type:"通过附近的人添加",
            value:"通过附近的人添加"
        },
        {
            type:"通过摇一摇添加",
            value:"通过摇一摇添加"
        },
        {
            type:"通过漂流瓶添加",
            value:"通过漂流瓶添加"
        },
        {
            type:"通过扫一扫添加",
            value:"通过扫一扫添加"
        },
        {
            type:"公众号",
            value:"公众号"
        },
        {
            type:"雷达",
            value:"雷达"
        },
        {
            type:"通过Google联系人添加",
            value:"通过Google联系人添加"
        },
        {
            type:"通过LinkedIn添加",
            value:"通过LinkedIn添加"
        }
    ];
    import {
        chatFriendList,
        chatSessionList,
        getFriendTag
    } from '@/utils/api-im.js'
    import {
        mapMutations,
        mapGetters
    } from 'vuex'
    export default {
        name: "searchBox",
        data() {
            return {
                selectIndex: 1,
                searchValue: '',
                inputFocus: false,
                isactive: false,
                timeout: null,
                showtip: false,
                tiplistdata:[],
                tiplist:[],
                friendstate: [{
                    id: '',
                    name: '全部'
                    },{
                    id: 0,
                    name: '正常状态'
                    }, {
                    id: 1,
                    name: '已被对方删除'
                    }],
                passiveAddWaySourceGroup:passiveAddWaySourceGroup,
                passway:passiveAddWaySourceGroup,
                value1: [],
                input1:'',
                value2: [],
                input2:'',
                value3: null
            }
        },
        created() {
            this.searchValue = ''
        },
        computed: {
            ...mapGetters('im', [
                'selTeam'
            ])
        },
        props:{
            seltype:{
                type:String,
                default: ''
            }
        },
        mounted() {
            // $(document).on('click',()=>{
            //     this.showtip = false
            // })
            // $(document).on('mouseup',()=>{
            //     this.showtip = false
            // })
        },
        watch: {
            searchValue(curVal, oldVal) {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.searchfriend(curVal);
                }, 300);
            },
            value1(){
               this.ifshowactive()
            },
            value2(){
               this.ifshowactive()
            },
            value3(){
                this.ifshowactive()
            },
            'selTeam.activeindex'(){
                this.ifshowactive()
            }
        },
        methods: {
            ...mapMutations('im', [
                'SEARCHINFO'
            ]),
            ifshowactive(){
                console.log(this.value3,'this.value3')
                if(this.value3 !==null || this.value2.length>0 || this.value1.length>0){
                    this.isactive = true
                    this.searchfriend(this.searchValue,true)
                }else{
                    this.isactive = false
                    if(this.searchValue == ''){
                        this.$emit('changeselectIndex',{
                            type:false,
                            remark: this.searchValue,
                            friendTags: this.value1,
                            addWaySource: this.value2,
                            friendDel: this.value3
                        })
                    }else{
                        this.searchfriend(this.searchValue,true)
                    }
                }
            },
            reset(){
                this.isactive = false
                this.value1 = [],
                this.value2 = [];
                this.value3 = null
                console.log(this.searchValue,this.searchValue == '')
                if(this.searchValue == ''){
                    this.$emit('changeselectIndex',{
                        type:false,
                        remark: this.searchValue,
                        friendTags: this.value1,
                        addWaySource: this.value2,
                        friendDel: this.value3
                    })
                }else{
                    this.searchfriend(this.searchValue);
                }
            },
            selall(type,bool){
                let arr = []
                if(type === "tip"){
                    if(bool){
                        this.tiplist.forEach(v => {
                            arr.push(v.id)
                        });
                        this.value1 = arr
                    }else{
                        this.value1 = []
                    }
                }
                if(type === "way"){
                    if(bool){
                        this.passway.forEach(v => {
                            arr.push(v.value)
                        });
                        this.value2 = arr
                    }else{
                        this.value2 = []
                    }
                }
            },
            changeinput(type){
                let arr = []
                if(type === "tip"){
                    if(this.input1){
                        this.tiplistdata.forEach(v => {
                            if(v.name.indexOf(this.input1) != -1){
                                arr.push(v)
                            } 
                        });
                        this.tiplist = arr
                        
                    }else{
                        this.tiplist = [...this.tiplistdata]

                    }
                    setTimeout(res=>{
                        if(this.tiplist.length>0){
                            this.$refs.input1val.focus()    
                        }else{
                            this.$refs.input1no.focus()
                        }
                    },10)
                }
                if(type === "way"){
                    if(this.input2){
                        this.passiveAddWaySourceGroup.forEach(v => {
                            if(v.value.indexOf(this.input2) != -1){
                                arr.push(v)
                            } 
                        });
                        this.passway = arr
                    }else{
                        this.passway = [...this.passiveAddWaySourceGroup]
                    }
                    setTimeout(res=>{
                        if(this.passway.length>0){
                            this.$refs.input2val.focus()    
                        }else{
                            this.$refs.input2no.focus()
                        }
                    },10)
                }
            },
            gettips(){
                this.showtip = true
                this.$get(getFriendTag).then(res=>{
                    console.log(res.data)
                    this.tiplist = res.data.data
                    this.tiplistdata = res.data.data
                })
            },

            // 搜索状态
            searchshow() {
                this.inputFocus = true;
            },

            //选择标签搜索
            tipsearch() {
                console.log(this.value1,this.value2,this.value3)
                // this.searchfriend(this.searchValue,true)
                this.showtip = false
            },

            //搜索
            searchfriend(inputVal,bool) {
                if(!bool){
                    if (this.searchValue == '') {
                        this.searchclose()
                        return false
                    }
                }
                sessionStorage.setItem('searchValue',this.searchValue)
                const url = this.seltype == "chat" ? chatSessionList : chatFriendList
                const queryChatSessionType = this.seltype == "chat" ? 3 : ''
                this.$post(url, {
                    remark: this.searchValue,
                    friendTags: this.value1,
                    addWaySource: this.value2,
                    friendDel: this.value3,
                    current:1,
                    queryChatSessionType:queryChatSessionType,
                    queryListGroupType:this.selTeam.type,
                    wechatid:this.selTeam.id
                }).then(res => {
                    if (this.searchValue == inputVal) {
                        if (res.data.code == 200) {
                            let sdate = {
                                searchtxt: this.searchValue,
                                data: res.data.data
                            }
                            this.$emit('changeselectIndex',{
                                type:true,
                                remark: this.searchValue,
                                friendTags: this.value1,
                                addWaySource: this.value2,
                                friendDel: this.value3,
                                seltype:this.seltype,
                                isnew:Math.random()
                            })
                            this.SEARCHINFO(sdate)
                        } else {
                            this.$toast(res.data.msg);
                        }
                    }
                }).catch(err => {
                    // this.$toast(res);
                })
            },
            searchclose() {
                this.inputFocus = false
                this.searchValue = ''
                if(this.value1.length == 0 && this.value2.length == 0 && this.value3 === null){
                    this.$emit('changeselectIndex',{
                        type:false,
                        remark: this.searchValue,
                        friendTags: this.value1,
                        addWaySource: this.value2,
                        friendDel: this.value3
                    })
                }else{
                    this.searchfriend('',true)
                }
            },
        }
    }
</script>

<style lang="less" scoped>

    /* 搜索框 */
    .searchBox {
        width: calc(100% - 105px);
        padding-left: 38px;
        margin: 0 0 15px 18px;
        height: 36px;
        background: rgba(248,249,250,1);
        border: 1px solid rgba(233,235,236,1);
        position: relative;
        border-radius: 18px;

        .btn_shai {
            position: absolute;
            right: -44px;
            top: 0;
            display: block;
            width: 38px;
            height: 38px;
            text-align: center;
            line-height: 38px;
            color: #666;
            font-size: 20px;

            &.active{
                color: #0099FF;
            }
        }

        input {
            width: calc(100% - 35px);
            padding-right: 35px;
            height: 36px;
            line-height: 36px;
            background: transparent;
            font-size: 14px;
        }

        i {
            position: absolute;
            left: 17px;
            top: 11px;
            font-size: 18px;
        }

        a {
            position: absolute;
            right: 11px;
            top: 10px;
        }

        .tipbox {
            position: absolute;
            width: 504px;
            height: 320px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
            border-radius: 8px;
            left: 0px;
            top: 50px;
            background: #fff;
            z-index: 2;
            font-size: 14px;

            .tiplist{
                padding:24px 22px;
                height: 210px;

                li{
                    height: 32px;
                    text-align: center;
                    line-height: 32px;
                    padding: 0 8px;
                    background:rgba(218,222,224,0.06);
                    border-radius:2px;
                    border:1px solid rgba(218,222,224,0.6);
                    float: left;
                    color: #707478;
                    margin: 0 8px 12px 0;
                    font-size: 14px;
                    cursor: pointer;

                    &.active{
                        background:rgba(236,245,255,1);
                        border:1px solid rgba(224,237,255,1);
                        color: #0099FF;
                    }
                }
            }
        }
    }

    .searchInput {
        width: calc(100% - 85px);
        padding-left: 18px;
        background: rgba(218, 222, 224, 0.3);

        i {
            position: initial;
        }
    }
</style>
<style lang="less">
    .search_sel{
        padding: 12px 0;
        .sel_item{
            margin-bottom: 20px;
            &>span{
                display: inline-block;
                width: 88px;
                text-align: right;
                color: #2a2a2a;
            }
            .el-select__tags{
                flex-wrap:inherit;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
            }
            .el-tag--light{
                background:rgba(237,245,255,1);
                border-color: rgba(237,245,255,1);
                border-radius: 12px;
                .el-select__tags-text{
                    color: #5B97E5;
                }
                i{
                    background-color: transparent;
                    right: -3px;
                    top:50%;
                    transform: translateY(-50%) scale(0.7);
                    &:hover{
                        background-color: #C0C4CC;
                    }
                }
            }
        }
        .dialog-footer{
            line-height: 32px;
            color: #fff;
            height:32px;
            text-align: right;
            margin-right: 10px;
        }
    }
    .searchsel_con{
        max-height: 168px;
        overflow-y: auto;
        position: relative;
        z-index: 2;
    }
    .toolbox{
        .el-input{
            padding: 5px;
            width: 210px;
        }
        .selbtn_box{
            margin: 5px 0;
            text-align: center;
        }
    }
    .emptybox{
        padding-top: 5px;
        .empty{
            color: #999;
            text-align: center;
            margin: 20px;
        }
    }
    .search_select_box{
        .el-select-dropdown__item{
            padding: 0 10px;
        }
        .el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after{
            right: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/customerservice/components/search.vue